/*
    @Auther Shani Rajkali
    @time 19:44 14/02/2020
*/
export class BaseModel {
    id?: any = null;
    person_id?: any = null;
    financial_id?: any = null;
    creation_date?: any = null;
    updated_date?: any = null;
    personId?: any = null;
    financialId?: any = null;
}

export class DataModel {
    data: any = null;
    error: any = null;
    message: String = null;
    status: boolean = null;
    status_code: Number = null;
}
